module.exports = __webpack_public_path__ + "static/media/okta-login.9cfdde4a.svg";